import {
	toolkitCategoriesV1,
	toolkitV1,
	toolkitTaxonomyV1,
	toolkitSearchV1,
	draftToolkitsV1,
	draftToolkitV1
} from './endpoints'
import { getRequest } from './axiosBase'

export const fetchToolkitsV1 = async () => {
	const { data } = await getRequest(toolkitCategoriesV1)
	return data
}

export const fetchToolkitV1 = async (nnid) => getRequest(`${toolkitV1}/${nnid}`)

export const fetchToolkitTaxonomyV1 = async () => {
	const { data } = await getRequest(toolkitTaxonomyV1)
	return data
}

export const fetchToolkitSearchV1 = async (searchTerm, roleIds, typeIds) =>
	getRequest(
		`${toolkitSearchV1}?search=${searchTerm}&role_id=${roleIds}&type_id=${typeIds}`
	)

export const fetchDraftToolkitsV1 = async () => {
	const { data } = await getRequest(draftToolkitsV1)
	return data
}

export const fetchDraftToolkitV1 = async (nnid) =>
	getRequest(`${draftToolkitV1}/${nnid}`)
